import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-xl-12" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "px-9 pt-7 card-rounded h-275px w-100 bg-primary" }
const _hoisted_4 = { class: "d-flex flex-stack" }
const _hoisted_5 = { class: "m-0 text-white fw-bolder fs-3" }
const _hoisted_6 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_7 = { class: "fw-bold fs-7" }
const _hoisted_8 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_9 = {
  class: "\n          shadow-xs\n          card-rounded\n          mx-9\n          mb-9\n          px-6\n          py-9\n          position-relative\n          z-index-1\n          bg-body\n        ",
  style: {"margin-top":"-100px"}
}
const _hoisted_10 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_11 = { class: "symbol-label bg-lighten" }
const _hoisted_12 = { class: "svg-icon svg-icon-1" }
const _hoisted_13 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_14 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_15 = {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
}
const _hoisted_16 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "fw-bolder fs-5 text-gray-800 pe-1" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "svg-icon svg-icon-5 svg-icon-success ms-1"
}
const _hoisted_22 = {
  key: 1,
  class: "svg-icon svg-icon-5 svg-icon-danger ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("DashboardSummary.Title")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("DashboardSummary.CurrentAl")), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$n(_ctx.currentAl.casino, "currency")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass([[index !== _ctx.items.length && 'mb-7'], "d-flex align-items-center"])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_inline_svg, {
                    src: item.icon
                  }, null, 8, ["src"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("a", _hoisted_15, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(item.description), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (item.description === 'Members')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$n(item.stats)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$n(item.stats, "currency")), 1))
                ]),
                (item.arrow === 'up')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr066.svg" })
                    ]))
                  : (item.arrow === 'down')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr065.svg" })
                      ]))
                    : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}